import { HLAEngineResultGroup } from "../types/shared/v2/HLAEngineResultGroup"
import { HLAEngineRule, HLAEngineRuleInactivation } from "../types/shared/v2/HLAEngineRule"
import { HLAEngineVariable } from "../types/shared/v2/HLAEngineVariable"
import { HLAResultRef } from "../types/shared/v2/HLAResult"
import { ObjectFilter, PrivacyDomain, QueryObjectsOptions } from "../util/objects"
import { CreateObjectRequestAction, DeleteObjectRequestAction, FetchObjectRequestAction, QueryObjectsRequestAction, UpdateObjectRequestAction, createObject, deleteObject, fetchObject, queryObjects, updateObject } from "./objects"

export const HLA_ENGINE_RULE_NAMESPACE = 'hla-engine-rule-v1'

export function queryPublicHLAEngineRules(filter?: ObjectFilter, options?: QueryObjectsOptions): QueryObjectsRequestAction {
    return queryObjects(HLA_ENGINE_RULE_NAMESPACE, PrivacyDomain.Public, filter, options)
}

export function updatePublicHLAEngineRule(objectId: string, data: Partial<HLAEngineRule>, partial?: boolean): UpdateObjectRequestAction {
    return updateObject(HLA_ENGINE_RULE_NAMESPACE, PrivacyDomain.Public, objectId, data, partial, { tenant: '*' })
}

export function createPublicHLAEngineRule(data: HLAEngineRule): CreateObjectRequestAction {
    return createObject(HLA_ENGINE_RULE_NAMESPACE, PrivacyDomain.Public, data, { tenant: '*' })
}

export function deletePublicHLAEngineRule(objectId: string): DeleteObjectRequestAction {
    return deleteObject(HLA_ENGINE_RULE_NAMESPACE, PrivacyDomain.Public, objectId, { tenant: '*' })
}

export const HLA_ENGINE_VARIABLE_NAMESPACE = 'hla-engine-variable-v1'

export function queryPublicHLAEngineVariables(filter?: ObjectFilter, options?: QueryObjectsOptions): QueryObjectsRequestAction {
    return queryObjects(HLA_ENGINE_VARIABLE_NAMESPACE, PrivacyDomain.Public, filter, options)
}

export function queryPatientHLAEngineVariables(inlogId: string): QueryObjectsRequestAction {
    return queryObjects(HLA_ENGINE_VARIABLE_NAMESPACE, PrivacyDomain.Public, { or: [{ exist: { 'ref.patient.inlogId': false } }, { eq: { 'ref.patient.inlogId': inlogId } }] }, { hydrate: true })
}

export function updatePublicHLAEngineVariable(objectId: string, data: Partial<HLAEngineVariable>, partial?: boolean): UpdateObjectRequestAction {
    return updateObject(HLA_ENGINE_VARIABLE_NAMESPACE, PrivacyDomain.Public, objectId, data, partial)
}

export function createPublicHLAEngineVariable(data: HLAEngineVariable): CreateObjectRequestAction {
    return createObject(HLA_ENGINE_VARIABLE_NAMESPACE, PrivacyDomain.Public, data)
}

export function deletePublicHLAEngineVariable(objectId: string): DeleteObjectRequestAction {
    return deleteObject(HLA_ENGINE_VARIABLE_NAMESPACE, PrivacyDomain.Public, objectId)
}

export const HLA_ENGINE_RUNE_INACTIVATION_NAMESPACE = 'hla-engine-rule-inactivation-v1'

export function queryPublicHLAEngineRuleInactivations(filter?: ObjectFilter, options?: QueryObjectsOptions): QueryObjectsRequestAction {
    return queryObjects(HLA_ENGINE_RUNE_INACTIVATION_NAMESPACE, PrivacyDomain.Public, filter, options)
}

export function updatePublicHLAEngineRuleInactivation(objectId: string, data: Partial<HLAEngineRuleInactivation>, partial?: boolean): UpdateObjectRequestAction {
    return updateObject(HLA_ENGINE_RUNE_INACTIVATION_NAMESPACE, PrivacyDomain.Public, objectId, data, partial)
}

export function createPublicHLAEngineRuleInactivation(data: HLAEngineRuleInactivation): CreateObjectRequestAction {
    return createObject(HLA_ENGINE_RUNE_INACTIVATION_NAMESPACE, PrivacyDomain.Public, data)
}

export function deletePublicHLAEngineRuleInactivation(objectId: string): DeleteObjectRequestAction {
    return deleteObject(HLA_ENGINE_RUNE_INACTIVATION_NAMESPACE, PrivacyDomain.Public, objectId)
}

export const HLA_ENGINE_TRACE_NAMESPACE = 'hla-engine-trace-v1'

export function queryPublicHLAEngineTraces(filter?: ObjectFilter, options?: QueryObjectsOptions): QueryObjectsRequestAction {
    return queryObjects(HLA_ENGINE_TRACE_NAMESPACE, PrivacyDomain.Public, filter, options)
}

export const HLA_ENGINE_RESULT_NAMESPACE = 'hla-engine-result-v1'

export function queryPublicHLAEngineResults(filter?: ObjectFilter, options?: QueryObjectsOptions): QueryObjectsRequestAction {
    return queryObjects(HLA_ENGINE_RESULT_NAMESPACE, PrivacyDomain.Public, filter, options)
}

export function queryPatientHLAEngineResults(inlogId: string): QueryObjectsRequestAction {
    return queryPublicHLAEngineResults({ eq: { "ref.patient.inlogId": inlogId } }, { hydrate: true })
}

export const HLA_ENGINE_RESULT_GROUP_NAMESPACE = 'hla-engine-result-group-v1'


export function fetchPublicHLAEngineResultGroup(objectId: string): FetchObjectRequestAction {
    return fetchObject(HLA_ENGINE_RESULT_GROUP_NAMESPACE, PrivacyDomain.Public, objectId)
}

export function queryPublicHLAEngineResultGroups(filter?: ObjectFilter, options?: QueryObjectsOptions): QueryObjectsRequestAction {
    return queryObjects(HLA_ENGINE_RESULT_GROUP_NAMESPACE, PrivacyDomain.Public, filter, options)
}

export function updatePublicHLAEngineResultGroup(objectId: string, data: Partial<HLAEngineResultGroup>, partial?: boolean): UpdateObjectRequestAction {
    return updateObject(HLA_ENGINE_RESULT_GROUP_NAMESPACE, PrivacyDomain.Public, objectId, data, partial)
}

export function createPublicHLAEngineResultGroup(data: HLAEngineResultGroup): CreateObjectRequestAction {
    return createObject(HLA_ENGINE_RESULT_GROUP_NAMESPACE, PrivacyDomain.Public, data)
}

export function deletePublicHLAEngineResultGroup(objectId: string): DeleteObjectRequestAction {
    return deleteObject(HLA_ENGINE_RESULT_GROUP_NAMESPACE, PrivacyDomain.Public, objectId)
}